<script>
  import {filter_list_for_curator, flowId, groups, info_client, ordering} from '../../stores';
  import { onDestroy, onMount } from 'svelte';
  import { api } from '../../../helpers/index.js';
  import { createEventDispatcher } from 'svelte';
  import { _ } from 'svelte-i18n';
  import { location } from 'svelte-spa-router';

  import Filter from '../Filter.svelte';

  const dispatch = createEventDispatcher();

  const isMobile = screen.width <= 576

  const sortOptions = [
    { id: 1, name: $_('creationDate'), value: '' },
    { id: 2, name: $_('newComments'), value: '-last_comment_date' },
  ];

  const getFlows = async () => {
    const response = await api('/api/v1/feed/filters/list/');

    if (!response.ok) {
      changeToken(response.status);
      return;
    }

    const filterFlowForCurators = await response.json();

    filter_list_for_curator.update(() => filterFlowForCurators);
  };

  onMount(async () => {
    if ($info_client.is_staff) {
      await getFlows();
    };
  });

  onDestroy(() => {
    flowId.set(null);
    ordering.set('');
  });
</script>

{#if $info_client.is_staff}
  <div class="flex filters mt-2" style:margin-top={$groups.length > 1 && isMobile && $location.includes('listnews') ? '50px' : '0'}>
    <div class="filter">
      <Filter
        options={$filter_list_for_curator.flows}
        noSelectedText={$_('searchByFlow')}
        on:change={(e) => dispatch('change', { 
          type: 'flow', 
          option: e.detail.option,
        })}
      />
    </div>

    <div class="ml-4 filter">
      <Filter
        options={sortOptions}
        noSelectedText={$_('sortingMethod')}
        on:change={(e) => dispatch('change', { 
          type: 'ordering', 
          option: e.detail.option,
        })} 
      />
    </div>
  </div>
{/if}

<style lang="scss">
  @media (max-width: 768px) {
    .filters {
      flex-direction: column;
    }

    .filter {
      margin-left: 0;
    }
  }
</style>